const FEATURE_CHATBOT = {
    buttonId: 'chatBotButton',
    windowId: 'ChatbotWindow',
    featureUrl: 'https://public-chatbot.paysera.net/',
};

let chatWindow = null;

function createChatBotButton() {
    const chatBotButton = document.createElement('button');
    chatBotButton.id = FEATURE_CHATBOT.buttonId;
    
    const icon = document.createElement('i');
    icon.classList.add('far', 'fa-comment');
    icon.style.margin = '0';
    chatBotButton.appendChild(icon);
    
    Object.assign(chatBotButton.style, {
        position: 'fixed',
        padding: '0',
        bottom: '20px',
        right: '20px',
        width: '40px',
        height: '40px',
        backgroundColor: '#007bff',
        color: '#fff',
        border: 'none',
        borderRadius: '50%',
        zIndex: '1001',
        cursor: 'pointer',
        fontSize: '18px',
        lineHeight: '14px',
        boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
    });

    document.body.appendChild(chatBotButton);
    
    chatBotButton.addEventListener('click', () => {
        if (chatWindow && !chatWindow.closed) {
            chatWindow.focus();
            return;
        }
        
        chatWindow = window.open(
            FEATURE_CHATBOT.featureUrl,
            FEATURE_CHATBOT.windowId,
            'width=800,height=600,left=100,top=100,toolbar=no,location=no,menubar=no,scrollbars=yes,resizable=yes'
        );
        
        if (chatWindow) {
            chatWindow.focus();
        } else {
            window.open(FEATURE_CHATBOT.featureUrl, '_blank');
        }
    });
}

document.addEventListener('DOMContentLoaded', () => {
    createChatBotButton();
});
